import {IUserFile} from 'app/modules/discovery/core'
import toastr from 'toastr'
import {announceReturn, announceSend} from '../api/utils/announce'

export async function postUserFileToS3(userFile: IUserFile, file: File) {
  if (!userFile.__upload_link?.url || !userFile.__upload_link.fields) {
    toastr.error(`No upload link was returned.`)
    throw new Error(`No upload link was returned.`)
  }

  const formData = new FormData()
  type FieldType = 'key' | 'AWSAccessKeyId' | 'policy' | 'signature' | 'x-amz-security-token'
  const fields: FieldType[] = [
    'key',
    'AWSAccessKeyId',
    'policy',
    'signature',
    'x-amz-security-token',
  ]
  for (const field of fields) {
    if (userFile.__upload_link.fields[field] !== undefined) {
      formData.append(field, userFile.__upload_link.fields[field] ?? '')
    }
  }
  formData.append('file', file)

  const url = userFile.__upload_link.url
  announceSend('post', url, userFile.__upload_link.fields)
  // Should probably migrate this to Axios, but I got it working using fetch and now I'd
  // rather not touch it.
  await fetch(url.replace('aws-local', 'localhost'), {
    method: 'POST',
    body: formData,
  })
  announceReturn('post', url, userFile.__upload_link.fields)
}
